export class EmailTemplate {
    code: string;
    name: string;
    content: string;
    isHtml: boolean;
    sortBy: string;
}




// WEBPACK FOOTER //
// ./src/app/models/emailTemplate.ts